import { BMAChannelSaga } from './channel';
import { BMAResultSaga } from './result';
import { BMASimulationSaga } from './simulation';

export default [
  BMAChannelSaga,
  BMASimulationSaga,
  BMAResultSaga
]